module.exports = __webpack_public_path__ + "static/media/Surat-Tugas.8f368554.png";